import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'dueDate',
})
export class DueDatePipe implements PipeTransform {
	transform(value: string | Date): boolean {
		const currentDate = new Date();
		const inputDate = new Date(value);

		return inputDate < currentDate;
	}
}
